import { render, staticRenderFns } from "./category-custom.vue?vue&type=template&id=28bd9698"
import script from "./category-custom.vue?vue&type=script&lang=js"
export * from "./category-custom.vue?vue&type=script&lang=js"
import style0 from "./category-custom.vue?vue&type=style&index=0&id=28bd9698&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports